import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { pkPerkProgress } from '../../../../constants/ProXtraPerks';
import { RenderPerkPLCCSpend } from '../commons/PerkProgressSpendCommons';
var PerkBlurb = function (_a) {
    var isMobile = _a.isMobile;
    var classes = isMobile ? '' : 'sui-pl-5';
    return (React.createElement(Typography, { variant: "body-lg", className: classes }, pkPerkProgress.perkSpendDescription));
};
export var PerkSpend = function (props) {
    var isMobile = props.isMobile;
    return (React.createElement("div", { className: "PerkProgress__PerkSpend" },
        React.createElement(PerkBlurb, { isMobile: isMobile }),
        React.createElement(RenderPerkPLCCSpend, null)));
};
